import React from "react";

function Amount({ amount, getRowStyle, shouldShowRow }: any) {
  return (
    <div className="amounts">
      {amount?.map((item: any, i: number) => {
        const label = String(item?.name || "")
          .toLowerCase()
          .replace(/\s+/g, "");
        const isNetTotal = label === "nettotal";

        if (typeof shouldShowRow === "function" && !shouldShowRow(item)) {
          return null;
        }

        return (
          <div
            className={`datas${isNetTotal ? " nettotal-row" : ""}`}
            style={
              typeof getRowStyle === "function" ? getRowStyle(item) : undefined
            }
            key={i}
          >
            <span>{item?.name}</span>
            <span>{item?.value}</span>
          </div>
        );
      })}
    </div>
  );
}

export default Amount;
